import React from "react";
import { Switch } from "antd";

export function FullyKycBadge({ value, size = "sm" }) {
  const isOn = Boolean(value);
  const isLarge = size === "lg";

  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${
        isLarge ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs"
      } ${isOn ? "success_tag" : "bg-[#F1F2F4] text-[#6D6B77]"}`}
    >
      {isOn ? "Fully verified" : "Not fully"}
    </span>
  );
}

export function FullyKycToggle({ checked, onChange, className = "", disabled = false, hint = "Optional. You can change this anytime after approval." }) {
  const isOn = Boolean(checked);

  return (
    <div className={`flex items-center justify-between gap-4 rounded-lg bg-[#F6F6F8] px-4 py-3 ${disabled ? "opacity-60 pointer-events-none" : ""} ${className}`}>
      <div className="text-left">
        <p className="text-sm font-semibold text-[#2F2B3D]">Mark as Fully KYC</p>
        <p className="text-xs text-[#8A8894] mt-0.5">{hint}</p>
      </div>
      <Switch
        checked={isOn}
        onChange={onChange}
        disabled={disabled}
        checkedChildren="Yes"
        unCheckedChildren="No"
      />
    </div>
  );
}

export default FullyKycBadge;
